/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import {createDateStrForV7HiddenInputFromSections} from "@mui/x-date-pickers/internals";

const { info, dark,background ,secondary} = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  '&::-webkit-scrollbar':{
    width: '6px !important',
    height: '6px',
  },
  '&::-webkit-scrollbar-track':{
    background: background.default,
  },
  '&::-webkit-scrollbar-thumb': {
    background: secondary.main,
    borderRadius: '6px',
  },
  '&::-webkit-scrollbar-thumb:hover ':{
    background: secondary.focus
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 50ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },

};

export default globals;
